import React from 'react'
import {
    Grid,
    Header,
    Message,
    Form,
    Button,
    Modal,
    Dropdown,
    Checkbox,
    Progress
} from "semantic-ui-react";
import {ReactMic} from "react-mic";
import '../../style.css'

function Pronunciation(props) {


    return (
        <>
            <br/>
            <Grid className='center aligned'>
                <Grid.Row>
                    <Header as='h1'>Pronunciation Practice</Header>
                </Grid.Row>
                <Grid.Row>
                    <Message color='teal'>
                        <p style={{color: 'black'}}>
                            Click on the word/phrase to hear the correct pronunciation.
                            <br/>
                            Use the dropdown below to choose an assignment to work on.
                        </p>
                    </Message>
                </Grid.Row>
            </Grid>

            {
                props.loading ?
                    <Grid centered={true}>
                        <Grid.Row>
                            <Progress percent={props.progress} indicating progress
                                      style={{width: 500}}>{props.progressText}</Progress>
                        </Grid.Row>
                    </Grid>
                    :

                    <Grid centered={true}>
                        <Grid.Row>
                            <Dropdown
                                onChange={props.handleAssignmentChange}
                                options={props.assignmentOptions}
                                placeholder='Choose an assignment'
                                selection
                                value={props.assignmentNum}
                            />
                        </Grid.Row>
                    </Grid>
            }
            {
                props.assignmentChosen ?
                    <Message color='blue' style={{marginLeft: 50, marginRight: 50, marginBottom: 100}}>
                        <Grid className='center aligned'>


                            <Grid.Row>
                                {
                                    props.buttons
                                }
                            </Grid.Row>

                            <Grid.Row>
                                <Form.Input
                                    label={`Difficulty Level: (${props.timer / 1000} second delay) `}
                                    min={2000}
                                    max={4000}
                                    name='timer'
                                    onChange={props.handleSlider}
                                    step={100}
                                    type='range'
                                    value={props.timer}
                                />
                                {
                                    props.isClicked ?
                                        <Button className='startQuiz' icon='stop' onClick={props.stopQuiz}
                                                circular
                                                style={{marginLeft: 10}} color='red'/>
                                        :
                                        <Modal
                                            onClose={() => props.setOpen(false)}
                                            onOpen={() => props.setOpen(true)}
                                            open={props.open}
                                            trigger={
                                                <Button circular content='Quiz' className='startQuiz'
                                                        color='green'
                                                        icon='play'
                                                        style={{marginLeft: 10}}/>
                                            }>
                                            <Modal.Header>Pronunciation Quiz</Modal.Header>
                                            <Modal.Content>
                                                <Modal.Description>
                                                    <p>
                                                        A random card will change color and you need to say
                                                        the
                                                        correct
                                                        pronunciation before the computer does.
                                                        <br/>
                                                        The pace will pick up as the quiz goes on.
                                                    </p>
                                                </Modal.Description>
                                            </Modal.Content>
                                            <Modal.Actions>
                                                <Checkbox
                                                    checked={props.toggleRecording}
                                                    label='Record Your Audio'
                                                    onChange={props.handleToggleRecording}
                                                />
                                                <Button
                                                    content="Start"
                                                    labelPosition='right'
                                                    icon='play'
                                                    className='startQuiz'
                                                    onClick={props.startQuiz}
                                                    positive
                                                />
                                            </Modal.Actions>
                                        </Modal>
                                }
                            </Grid.Row>
                            {props.toggleRecording ?
                                <>
                                    <Grid.Row>

                                        <ReactMic
                                            record={props.record}
                                            className="sound-wave"
                                            onStop={props.onStop}
                                            backgroundColor='grey'
                                            strokeColor="green"
                                            mimeType='audio/mp3'
                                        />
                                        < audio src={props.blobURL} controls="controls"
                                                style={{marginTop: 20, marginLeft: 30}}/>


                                    </Grid.Row>
                                    {
                                        props.blobURL ?
                                            <Button onClick={props.handleSaveRecording}>Submit Recording</Button>
                                            :
                                            null
                                    }
                                    <Grid.Row>
                                        {
                                            props.success ?
                                                <Message color='green'>
                                                    <Header as='h1'>
                                                        Successfully Uploaded!
                                                    </Header>
                                                </Message>
                                                :
                                                null
                                        }
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Message>
                                            You may use the player to listen to your audio recording by pressing the Play button.<br/>
                                            If you are satisfied with your recording, you may submit it by pressing the Submit Recording button<br/><br/>
                                            <b>Note: Your audio recording will only be used for academic purposes. Your recording will only be heard by your professor</b>
                                        </Message>
                                    </Grid.Row>

                                </>
                                :
                                null
                            }


                        </Grid>

                    </Message>
                    :
                    null
            }


        </>
    )
}

export default Pronunciation
